import React, { useCallback, useMemo } from 'react'
import { Checkbox, Tooltip } from 'antd'
import { every, map } from 'lodash'
import PropTypes from 'prop-types'

import { STATUS_FLAG_FIELD } from '../../../common/constants'

import { MENU_CURATION_TASK_STATUS } from '../../../menu-curation-tasks/constants'
import { useUpdateDishesStatusFlagsMutation } from '../../hooks'

const DishTableCheckAllColumn = ({ dishes, taskStatus, isDisabled }) => {
  const statusFlagFieldName = useMemo(() => {
    if (taskStatus === MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value) {
      return STATUS_FLAG_FIELD.IS_TIER_ONE_DONE
    }

    if (taskStatus === MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value) {
      return STATUS_FLAG_FIELD.IS_CURATION_DONE
    }

    if (taskStatus === MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value) {
      return STATUS_FLAG_FIELD.IS_QA_DONE
    }

    return STATUS_FLAG_FIELD.IS_QC_DONE
  }, [taskStatus])

  const [updateStatusFlag] =
    useUpdateDishesStatusFlagsMutation(statusFlagFieldName)

  const dishIds = useMemo(() => map(dishes, 'id'), [dishes])

  const handleChange = useCallback(
    event => updateStatusFlag(dishIds, event.target.checked),
    [dishIds, updateStatusFlag],
  )

  const checkboxValue = useMemo(
    () => every(dishes, dish => dish[statusFlagFieldName]),
    [dishes, statusFlagFieldName],
  )

  const tooltipTitle = useMemo(() => {
    if (taskStatus === MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value) {
      return 'Set dishes tier one done'
    }

    if (taskStatus === MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value) {
      return 'Set dishes curation done'
    }

    return null
  }, [taskStatus])

  return (
    <Tooltip title={tooltipTitle}>
      <Checkbox
        checked={checkboxValue}
        onChange={handleChange}
        disabled={isDisabled}
      />
    </Tooltip>
  )
}

DishTableCheckAllColumn.propTypes = {
  dishes: PropTypes.arrayOf(PropTypes.object).isRequired,
  taskStatus: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
}

DishTableCheckAllColumn.defaultProps = {
  isDisabled: false,
}

export default DishTableCheckAllColumn
